module.exports = __webpack_public_path__ + "media/images/common/header/sub_search-2aaa0e63c6bb7b828e4654885fa4b15f.svg";